import React from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import "./whatwedo.css";
import Img1 from "./whatwedoimg1.png";
import Img2 from "./whatwedoing2.png";
import Img3 from "./whatimg1.png";
import Img4 from "./whatimg2.png";
import Img5 from "./whatimg3.png";
import Img6 from "./whatimg4.png";
import Img7 from "./whatimg5.png";
import Img8 from "./whatimg6.png";
import Img9 from "./whatimg7.png";
import Img10 from "./whatimg8.png";
import Img11 from "./whatimg9.png";
import Img12 from "./image1.png";
import Img13 from "./image2.png";
import Img14 from "./image3.png";
import Img15 from "./image4.png";
import Container from "react-bootstrap/Container";
const Whatwedo = () => {
  return (
    <>
      <Navb />

      <div className="whatwedo_top">
        <Container>
          <div className="whatwedo_top_heading">What we do</div>
          <div className="whatwedo_top_flex">
            <img src={Img1} alt="Img1" />
            <div className="whatwedo_top_flex_right">
              <div className="whatwedo_top_flex_right_heading">
                Social Activities
              </div>
              <p className="whiteP">
                Nandi is deeply committed to Corporate Social Responsibility
                (CSR), focusing on environmental sustainability, community
                empowerment, and education. Through local partnerships, we
                strive to create a positive impact. Our dedication to
                responsible business practices extends beyond profit, shaping a
                positive narrative for Nandi and the communities we serve.
              </p>
            </div>
          </div>
        </Container>
      </div>
      <div className="aboutusBot">
        <Container>
          <div className="aboutusBotContent">
            <div>
              <div className="blackHeading">Production standards</div>
              <div className="blackP">
                Nandi upholds top-tier production standards, emphasizing quality
                in sourcing, manufacturing, and quality control. Committed to
                consistency and customer satisfaction, we set the bar for
                excellence in production, delivering reliable, high-quality
                products.
              </div>
            </div>
            <img src={Img2} alt="Img2" />
          </div>
        </Container>
        <Container className="whatwedo_Box">
          <div className="whatwedo_card">
            <img src={Img3} alt="Img3" />
            <div className="whatHeading">Hygiene</div>
            <div
              className="blackP"
              style={{
                "padding-top": "2rem",
                "border-top": "1px solid #F3A32B",
                "text-align": "center",
              }}
            >
              We use industrial grade raw material. Our facilities are
              maintained to the highest standards of cleanliness and sanitation,
              ensuring that every product meets our rigorous hygiene criteria.
            </div>
          </div>
          <div className="whatwedo_card">
            <img src={Img4} alt="Img4" />
            <div className="whatHeading">Facts about Product</div>
            <div
              className="blackP"
              style={{
                "padding-top": "2rem",
                "border-top": "1px solid #F3A32B",
                "text-align": "center",
              }}
            >
              We go through thorough processes of skimming, rinsing, drying and
              grinding of the raw material for obtaining a clean and A+ quality
              of spices and grains and atta.
            </div>
          </div>
          <div className="whatwedo_card">
            <img src={Img5} alt="Img5" />
            <div className="whatHeading">Industrial Standards</div>
            <div
              className="blackP"
              style={{
                "padding-top": "2rem",
                "border-top": "1px solid #F3A32B",
                "text-align": "center",
              }}
            >
              We take regular quality tests for every batch of materials to
              decide the quality and if passed then the product is manufactured.
            </div>
          </div>
        </Container>
        {/* <div className="blackP" style={{ width: "90%", margin: "0px auto" }}>
          A culinary odyssey that began from the bottom ground with high
          motivation and an unmistakable resemblance to the dreams we aspired to
          bring to life. Our dedication unfolded in every step of our process.
          We weren't just makers; we were artisans shaping culinary experiences.
          From giving atta with a choker, symbolizing our pledge to offer the
          best, to the intricate dance of washing grains, drying, storing,
          filtering, skimming, and grinding. Each phase was a symphony of care,
          attention, and a relentless pursuit of perfection. But Nandi's story
          transcends the boundaries of our kitchen. Our aspirations reached
          beyond four walls; we aimed to grow our products from house to house,
          transcending borders and touching hearts across the entire country and
          the world. Atta, Maida, and Sooji weren't just ingredients; they were
          ambassadors of Indian taste, sharing the rich tapestry of our culinary
          heritage.
        </div> */}
      </div>
      <div className="ourVisits">
        <div className="whiteHeading" style={{ margin: "1px auto" }}>
          Our Visits
        </div>
        <img src={Img6} alt="Img6" />

        <Container className="whatwedo_top1">
          {/* <div className="whatwedo_top_heading">What we do</div> */}
          <div
            className="whatwedo_top_flex"
            // style={{ "flex-direction": "row-reverse" }}
          >
            <div className="whatwedoimg">
              <img src={Img8} alt="Img8" className="whatwedoimg1" />
              <img src={Img7} alt="Img7" className="whatwedoimg2" />
            </div>
            <div className="whatwedo_top_flex_right">
              <div className="whatwedo_top_flex_right_heading">
                Visit to ITC
              </div>
              <p className="whiteP" style={{"padding": "20px 10px"}}>
                ITC is our partner in provision of spices, especially turmeric,
                coriander and red chilly.Our team visited ITC in order to setup
                a strong and transparent connection with ITC, to grow the scope
                of fruitful business.
              </p>
              <p className="whiteP" style={{"padding": "20px 10px"}}>
                ITC Spices engages extensively with over 10,000 farmer partners
                across 170 villages with a crop area of over 35,000 hectares to
                offer customers the finest spices which comply with the most
                rigorous food safety norms. The business is uniquely positioned
                to implement large-scale interventions at the farm level, which
                focus intensely on building sustainability in terms of
                agricultural production, livelihoods and environmental
                resources.
              </p>
            </div>
          </div>
        </Container>

        <img src={Img9} alt="Img9" />
        <div className="whatwedo_top1">
          {/* <div className="whatwedo_top_heading">What we do</div> */}
          <Container
            className="whatwedo_top_flex"
            style={{ "flex-direction": "row-reverse" }}
          >
            <div
              className="whatwedo_img_2"
              // style={{
              //   display: "flex",
              //   "flex-direction": "column",
              //   gap: "1rem",
              // }}
            >
              <img src={Img10} alt="Img10" />
              <img src={Img11} alt="Img11" />
            </div>
            <div className="whatwedo_top_flex_right">
              <div className="whatwedo_top_flex_right_heading">
                Visit to Gul food Dubai
              </div>
              <p className="whiteP">
                Gulfood is the gold standard for the global F&B community, and
                the most trusted name and source of lucrative deals, knowledge,
                and networking. It’s the ultimate opportunity for retailers,
                food suppliers, distributors, wholesalers, chefs, thought
                leaders, and beyond to discover the latest products, connect
                with industry players, and explore the latest trends and
                innovations shaping the future.
              </p>
              <p className="whiteP">
                We visited Gul food for building new horizons in our
                international business and upheld the legacy developed in India,
                we met a lot of potential clients and partners and discovered
                scope of business across the seas.
              </p>
            </div>
          </Container>
        </div>
      </div>
      <div className="OurClients">
        <div
          className=" blackHeading OurClientsHeading"
          style={{ margin: "1px auto" }}
        >
          Our Clients
        </div>
        <Container className="OurClientsflex">
          <img src={Img12} alt="Img12" />
          <img src={Img13} alt="Img13" />
          <img src={Img14} alt="Img14" />
          <img src={Img15} alt="Img15" />
        </Container>
      </div>

      <Footer />
    </>
  );
};

export default Whatwedo;
